// extracted by mini-css-extract-plugin
export default {"left":"Znodr","center":"coa+b","right":"tSfTy","onImage":"_5cQEM","offImage":"fkudH"};